// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Mz3Z","footer":"Form_footer__3lsKD"};